import './DropDownBox.scss';
import { ChangeEvent, useState } from 'react';
import { IconRadioButton } from 'common/components/Icons/IconRadioButton/IconRadioButton';
import { CustomSwitch } from 'common/components/CustomSwitch/CustomSwitch';
export function DropDownBox(props: any) {
  const [active, setActive] = useState<boolean>(!!props.isActive || !!props.alwaysActive);
  const [selected, setSelected] = useState<any>(props.selectedItem);
  const [showOptions, setShowOptions] = useState<boolean>(active);

  const onToggle = (e: ChangeEvent, state: boolean) => {
    if (!props.alwaysActive) {
      setShowOptions(state);
      setActive(state);
      props.onToggle(state);
    }
  };

  const onSelect = (option: any) => {
    setSelected(option);
    props.onChange(option.value);
  };

  return (
    <li className="DropDownBox">
      <div>
        <span className={active ? '' : 'disabled'} onClick={() => setShowOptions(!showOptions)}>
          {`${props.data.label}: ${selected ? selected.label : ''}`}
        </span>
        <CustomSwitch checked={active} onChange={onToggle} />
      </div>
      <ul className={showOptions ? 'visible' : ''}>
        {props.data.options.map((option: any) => {
          return (
            <li key={option.label} onClick={() => onSelect(option)}>
              <IconRadioButton radioSize="little" toggle={selected?.label === option.label} />
              {option.label}
            </li>
          );
        })}
      </ul>
    </li>
  );
}
